import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as Sentry from '@sentry/vue'

Vue.config.productionTip = false

if (process.env.VUE_APP_ENVIRONMENT !== 'local') {
  const defaultIntegrations = Sentry.getDefaultIntegrations().filter(
    (integration) => integration.name !== 'Breadcrumbs'
  )
  Sentry.init({
    Vue,
    dsn: 'https://0a0dac14c1f6410b84aac98d395d0208@sentry.apiq.live/6',
    tracesSampleRate: 0,
    autoSessionTracking: false,
    defaultIntegrations: [...defaultIntegrations, Sentry.vueIntegration()]
  })
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
